module.exports = __webpack_public_path__ + "img/22a-lrn-spt-cat-5-icon-def.11fe5302.svg";